import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} OTengnér. All rights reserved.</p>
    </footer>
  )
}

export default Footer